import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpsRequestInterceptor } from './autheticate/http.interceptor';
import { SharedModule } from '../shared/shared.module';
import { ToastNotificationsModule } from 'ngx-toast-notifications';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ToastNotificationsModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ]
})
export class CoreModule { }
